import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css'; // Import the default CSS for the calendar
import prev_icon from "./assets/thin-chevron-round-left-icon.svg"
import forward_icon from "./assets/thin-chevron-round-right-icon.svg"
import './Calendar.css'; // Import your custom CSS file

const PrevIcon = ()=>{
  return(
    <img src={prev_icon} alt="" />
  )
}
const ForwardIcon = ()=>{
  return(
    <img src={forward_icon} alt="" />
  )
}
function MyCalendar() {
  const [date, setDate] = useState(new Date());

  return (
    <div className="calendar-container">
      <Calendar nextLabel={<ForwardIcon/>} prevLabel={<PrevIcon/>} defaultView='month' onChange={setDate} value={date} prev2Label={null} next2Label={null} />
    </div>
  );
}

export default MyCalendar;
